<template>
  <section class="py-6 bg-white">
    <div class="container">
      <div class="row g-4 align-items-start align-items-lg-center">
        <div class="col-lg-5">
          <h2 class="fw-bold display-6 fs-2 mb-2">Alianzas comerciales</h2>
          <p class="text-muted mb-0">
            Buscamos darte una mejor calidad de servicio; por eso nos aliamos con las siguientes empresas.
          </p>
        </div>

        <div class="col-lg-7">
          <div class="row row-cols-2 row-cols-sm-3 row-cols-md-4 g-3 g-sm-4 d-flex justify-content-center gap-4  gap-md-7">
            <div class="col">
              <div class="logo-tile d-flex justify-content-center align-items-center">
                <img src="@/assets/maquinar.png" class="logo-img" alt="Maquinar" />
              </div>
            </div>
            <div class="col">
              <div class="logo-tile d-flex justify-content-center align-items-center">
                <img src="@/assets/gmk.png" class="logo-img" alt="GMK" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<style scoped>
.logo-img {
  max-height: 56px;      
  width: auto;     
  object-fit: contain;
  filter: grayscale(100%);
  opacity: .85;
  transition: filter .2s ease, opacity .2s ease, transform .2s ease;
}
.logo-tile:hover .logo-img {
  filter: grayscale(0%);
  opacity: 1;
  transform: translateY(-2px);
}

.logo-tile {
  padding: .75rem 1rem;       
}

@media (max-width: 575.98px) {
  .logo-img { max-height: 48px; }
}
</style>
